import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import LeftPanel from "../../components/login/LeftPanel";
import LoginForm from "../../components/login/LoginForm";

import css from "./LoginPage.module.css";

const LoginPage = props => {
  const { className, rootClassName } = props;

  const classes = classNames(
    rootClassName || css.root,
    className
  );

  return (
    <div className={css.main}>

      <div className={css.container}>

        <div className={css.left}>
          <LeftPanel />
        </div>

        <div className={css.right}>
          <LoginForm />
        </div>

      </div>

    </div>
  );
};

LoginPage.defaultProps = {
  className: null,
  rootClassName: null,
};

LoginPage.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default LoginPage;